import React, { useState, useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw, X } from 'lucide-react';
import Button from '../UI/Button';
import './PWAUpdatePrompt.css';

/**
 * PWA 업데이트 알림 컴포넌트
 * 새로운 버전이 사용 가능할 때 사용자에게 알림을 표시합니다.
 */
function PWAUpdatePrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW Registered: ' + r);
    },
    onRegisterError(error) {
      console.log('SW registration error', error);
    },
    onNeedRefresh() {
      setShowPrompt(true);
      console.log('새 버전이 사용 가능합니다.');
    },
    onOfflineReady() {
      console.log('앱이 오프라인 사용 준비가 되었습니다.');
    },
  });

  const updateApp = async () => {
    setIsUpdating(true);
    try {
      await updateServiceWorker(true);
      // 업데이트 후 페이지 새로고침
      window.location.reload();
    } catch (error) {
      console.error('업데이트 실패:', error);
      setIsUpdating(false);
    }
  };

  const dismissUpdate = () => {
    setShowPrompt(false);
    setNeedRefresh(false);
  };

  // 오프라인 준비 완료 알림 (3초 후 자동 숨김)
  useEffect(() => {
    if (offlineReady) {
      const timer = setTimeout(() => {
        setOfflineReady(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [offlineReady, setOfflineReady]);

  if (!showPrompt && !offlineReady) return null;

  return (
    <>
      {/* 업데이트 알림 */}
      {showPrompt && (
        <div className="pwa-update-overlay">
          <div className="pwa-update-prompt">
            <div className="pwa-update-header">
              <div className="pwa-update-icon">
                <RefreshCw size={24} />
              </div>
              <div className="pwa-update-content">
                <h3>새 버전 사용 가능</h3>
                <p>Password Wallet의 새로운 버전이 있습니다. 업데이트하시겠습니까?</p>
              </div>
              <button
                className="pwa-update-close"
                onClick={dismissUpdate}
                disabled={isUpdating}
              >
                <X size={20} />
              </button>
            </div>
            <div className="pwa-update-actions">
              <Button
                variant="secondary"
                onClick={dismissUpdate}
                disabled={isUpdating}
              >
                나중에
              </Button>
              <Button
                variant="primary"
                onClick={updateApp}
                loading={isUpdating}
                disabled={isUpdating}
              >
                <RefreshCw size={16} />
                {isUpdating ? '업데이트 중...' : '지금 업데이트'}
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* 오프라인 준비 완료 알림 */}
      {offlineReady && (
        <div className="pwa-offline-toast">
          <div className="pwa-offline-content">
            <div className="pwa-offline-icon">✅</div>
            <span>오프라인에서도 사용할 수 있습니다!</span>
          </div>
        </div>
      )}
    </>
  );
}

export default PWAUpdatePrompt;